<template>
    <main-layout>
        <template #header>
            <main-header :title="'입출금 내역 확인' | translate"/>
        </template>
        <template #toolbar>
            <div class="search-select-wrapper">
                <select-box-filter-group
                    v-model="selectOptions"
                />
                <search-bar
                    :placeholder="'검색어' | translate"
                    v-model="selectOptions.searchKeyword"
                    style="width: 60%;"
                />
            </div>

        </template>
        <template #body>
            <div class="sortable-wrapper">
                <v-chip v-if="selectOptions.rentalcompanyId && currentSortName" small close class="sortable-column" @click:close="clearSort">
                    <span class="column-size-short">{{'정렬 : '+ currentSortName}}</span>
                </v-chip>
            </div>
            <no-library-bagic-table
                :table-data-res="tableDataRes"
                :disable-button="disableButton"
                :sort-options="sortOptions"
                :select-options="selectOptions"
                @page-number-plus="pageNumberPlus"
                @sort-options-data-change="sortOptionsDataChange"
            />
            <div class="loading_wrap" v-show="isLoading">
                <div class="loading"></div>
                <div class="loading"></div>
                <div class="loading"></div>
            </div>
        </template>

    </main-layout>
</template>

<script>
import MainLayout from "@/components/common/layout/MainLayout";
import SearchBar from "@/components/input/SearchBar";
import MainHeader from "@/components/common/layout/MainHeader";
import SelectBoxFilterGroup from "@/views/deposit/SelectBoxFilterGroup";
import headerDataList from "@/components/TagTable/headerDataList";
import {PATH} from "@/constants";
import NoLibraryBagicTable from "@/views/deposit/NoLibraryBagicTable";
import Deposit from "@/model/deposit";
import {cloneDeep} from "lodash";

export default {
    name: "DepositList",
    components: {
        NoLibraryBagicTable,
        MainLayout,
        MainHeader,
        SearchBar,
        SelectBoxFilterGroup
    },
    props: {
        conveyDataDeposit: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            isLoading: false,
            tableDataRes: [],
            selectOptions: {
                pageSize: 30,
                rentalcompanyId: undefined,
                baseSearchDateType: undefined,
                paymentStatusList: [],
                pageNumber: 1, //추가로드를 위한 데이터입니다.
                startDate: null,
                endDate: null,
                searchKeyword: undefined,//검색어,
            }, //모든 옵션 selectBox 에대한 데이터 입니다.
            disableButton: false,//추가로드버튼 클릭은 막기 위함입니다.,
            reqSortOptions:{//정렬 데이터를 요청에 필요한 형태로 변경하기 위함입니다.
                sortBy:undefined,
                sortDesc:undefined
            },
            sortOptions:{},//정렬 데이터를 쉽게 컨트롤하기 위해서 만들었습니다.


        }
    },
    computed: {
        currentSortName() {
            if(Object.keys(this.sortOptions).length ===0) return
            const columnText = headerDataList.DEPOSIT_LIST.DEPOSITS.find((item)=>{
                return item.key===Object.keys(this.sortOptions)[0]
            }).title
            return columnText
        }
    },
    watch: {
        /**
         * 매출 페이지상 테이블 데이터를 클릭하면 나오는 모달에서
         * 닫기를 눌러도 컴포넌트는 남아 있기때문에 다른 데이터를 클릭해도 바인딩이
         * 제대로 안일어난다. 그래서 watch를 걸어서 유동적으로 변경해줬습니다.
         */
        conveyDataDeposit: {
            deep: true,
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.selectOptions.rentalcompanyId = newValue.rentalcompanyId
                    this.selectOptions.accountId = newValue.accountId
                    this.selectOptions.billingId = newValue.billingId
                    this.tableDataLoad()
                }
            }
        },

        selectOptions: {
            deep: true,
            handler() {
                this.tableDataLoad()
            }
        },
    },


    methods: {
        clearSort(){
            this.sortOptions = {}
            this.reqSortOptions.sortBy = undefined
            this.reqSortOptions.sortDesc = undefined

        },
        /**
         * sortBy -> 정렬할 대상
         * sortDesc -> 오름차순 or 내림차순 (Boolean)

         * @param newValue
         */
        sortOptionsDataChange(newValue) {
            this.sortOptions=newValue
            const sortBy=[...Object.keys(this.sortOptions)]
            const sortDesc=[...Object.values(this.sortOptions)]
            this.reqSortOptions= {sortBy,sortDesc}
            this.tableDataLoad()
        },

        /**
         * pageNumber 데이터를 1씩 증가합니다.
         */
        pageNumberPlus() {
            this.selectOptions.pageNumber++
        },
        /**
         * 응답받은 데이터가 없거나 테이블 자체에 데이터가 없을때 추가로드 버튼을 비활성화 합니다.
         * @param reqData
         */
        disableAddLoadButton(reqData) {
            this.disableButton = !!reqData && !!reqData.length
        },
        /**
         * 징치 목록에서 테이블 데이터를 얻기위한 요청입니다.
         * 필터 옵션, 검색키워드, 페이지순서, 정렬이 달라지면 데이터 요청을합니다.
         * @param body
         * @returns {Promise<void>}
         */
        async tableDataLoad() {
            if(this.isLoading || !this.selectOptions.rentalcompanyId) return
            const param = cloneDeep(this.selectOptions)
            this.isLoading = true;
            if(param.pageNumber === 1){
                this.tableDataRes = []
            }
            try{
                const res = await this.$request(PATH.CMS.List)
                    .setObject({...param,...this.reqSortOptions})
                    .enqueue()
                const depositFormat = res.data.map((e) => new Deposit(e)._item);
                this.disableAddLoadButton(depositFormat)
                this.tableDataRes =[...this.tableDataRes, ...depositFormat]
                this.isLoading = false;
            }catch (e){
                this.isLoading = false;
                alert('조회실패')
            }
        },


    },
    created() {
        if (this.conveyDataDeposit) { //매출페이지상 테이블 데이터 클릭시 나오는 모달에서 임대업체 셀렉트 버튼 값 바인딩
            this.selectOptions.rentalcompanyId = this.conveyDataDeposit.rentalcompanyId
            this.selectOptions.accountId = this.conveyDataDeposit.accountId
            this.selectOptions.billingId = this.conveyDataDeposit.billingId
        }
    },
}
</script>

<style scoped>
.loading_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
}

.loading {
    width: 8px;
    height: 8px;
    background: #aaaaaa;
    border-radius: 50%;
    animation: loading-cricle 1.5s infinite ease-in-out;
    display: inline-block;
    margin-right: 8px;
}

.loading:nth-child(2) {
    animation-delay: .5s;
}

.loading:nth-child(3) {
    animation-delay: 1s;
}

@keyframes loading-cricle {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}

/*Search Box 부분 font 랑 사이즈 조정 부분입니다*/
>>> .v-input__control .v-input__slot .v-text-field__slot input {
    font-size: 11px;
    padding: 0;
}

>>> .v-input__control .v-input__slot fieldset {
    height: 47px;
}

/*search 부분이랑 select 부분 wrapper입니다*/
.search-select-wrapper {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    margin-bottom: 10px;

}
.sortable-wrapper{
    text-align: left;
}
.sortable-column{
    margin-bottom: 10px;
    background-color: #dddddd;
    font-size: 10px;
    width: 130px;
}
.column-size-short{
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
}
</style>